export default {"src":"/_next/static/media/FRSH.cd986b2b.svg","height":18,"width":18};